import { render, staticRenderFns } from "./UpcomingFeature.vue?vue&type=template&id=d28ad50a&scoped=true"
import script from "./UpcomingFeature.vue?vue&type=script&lang=js"
export * from "./UpcomingFeature.vue?vue&type=script&lang=js"
import style0 from "./UpcomingFeature.vue?vue&type=style&index=0&id=d28ad50a&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d28ad50a",
  null
  
)

export default component.exports